import { Query } from 'src/core/stores/data-store';
import DataStoreMock from './base/data-store';
import { DefaultRoleSummary } from 'src/stores/default-roles-store';
import { DefaultRoleMockData } from '../data-sources/default-role-summary';

export class DefaultRoleSummaryStoreMock extends DataStoreMock<DefaultRoleSummary> {
  public async load(_query: Partial<Query>) {
    this._state.set({
      isBusy: false,
      items: DefaultRoleMockData,
      count: DefaultRoleMockData.length,
    });
    return true;
  }
}
